import { viewAlphaQuote } from '@ui/features/alpha/state/endpoints/view-alpha-quote';
import type { ExtraReducerBuilder } from '@ui/features/alpha/types/state';

import * as reducers from '../reducers';

export function createViewAlphaQuoteReducer(builder: ExtraReducerBuilder) {
  builder.addMatcher(viewAlphaQuote.matchFulfilled, (state, action) => {
    reducers.setQuoteLines(state, {
      type: 'viewAlphaQuote/matchFulfilled',
      payload: {
        alphaQuote: action.payload,
      },
    });
  });
}
